import React from "react";
import { isEmpty } from "lodash";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import CredentialForm from "pages/_components/Forms/CredentialForm";
import Loader from "pages/_components/Loader";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import * as i18n from "util/i18n";
import { useAgreementSummary } from "./hooks/useAgreementSummary";
import AgreementSummary from "./components/AgreementSummary";

const AgreementSummaryPage = () => {
    const { newAgreement, handleSubmit, credentialType, handleBack } = useAgreementSummary();

    if (isEmpty(newAgreement)) {
        return <Loader />;
    }

    return (
        <>
            <Notification scopeToShow="/accounts/agreements/summaryForm" />
            <CustomProductHead titleId="account.agreement.request" onBack={handleBack}>
                <div className="toolbar-item view-title">
                    <ViewTitle id="account.agreement.request" />
                </div>
            </CustomProductHead>
            <MainContainer>
                <div className="container">
                    <h2 className="text-lead">{i18n.get("account.agreement.title")}</h2>
                    <AgreementSummary
                        title="account.agreement.title"
                        amount={newAgreement.amount}
                        productType={newAgreement.account.productType}
                        number={newAgreement.account.number}
                        currency={newAgreement.currency}
                        owner={newAgreement.owner}
                        expirationDate={newAgreement.expirationDate}
                        purpose={newAgreement.purpose}
                        tax={newAgreement.tax}
                        commission={newAgreement.commission}
                    />
                    <CredentialForm onSubmit={handleSubmit} credentialType={credentialType} />
                </div>
            </MainContainer>
        </>
    );
};

export default AgreementSummaryPage;
